/**
 * Meldet den Übergang nach „geöffnet“ — Pendant zu `AfterShow`/`OnShow` in
 * `IwmBaseSidebar.Show()`. Die Sichtbarkeit steuert in React der Aufrufer, deshalb hängt
 * die Meldung am Wechsel von `open`.
 */

import { useEffect, useRef } from 'react';

export function useOpenNotification(open: boolean, onShow?: () => void): void {
  const latest = useRef(onShow);
  latest.current = onShow;

  useEffect(() => {
    if (open) latest.current?.();
  }, [open]);
}
